/** @format */

import {Box, Chip} from '@mui/material';
import {styled} from '@mui/material/styles';

export const AiModuleContainer = styled(Box)(({theme}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  marginTop: '40px',
}));

export const SectionTitle = styled(Box)(({theme}) => ({
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 500,
  marginBottom: theme.spacing(3),
}));

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '24px',
}));

export const ModuleTitle = styled(Box)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
}));

export const ContentContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '1px',
  minHeight: 435,
  alignItems: 'stretch',
}));

export const BetaChip = styled(Chip)(({theme}) => ({
  backgroundColor: '#664214',
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
}));

export const MonitoringAlertBadge = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: '#b17629',
  color: '#fff',
  borderRadius: '9px',
  padding: '2px 8px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
}));
